import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LoadingService } from './loading.service';
import { standardHttpOptions } from '@models';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { KigSettings, KIG_SETTINGS } from '../../../settings/kig-settings';
import { of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { AskQuestionRequest } from '@models/AI/AskQuestionRequest.model';


@Injectable()

export class AIService {
  public standardHttpOptionsWithUser: any;

  private apiUrl: string;

  constructor(private http: HttpClient,
              private loadingService: LoadingService,
              @Inject(KIG_SETTINGS) private settings: KigSettings) {
    this.apiUrl = this.settings.apiUrl;
  }


  buildStandardHttpOptionsWithUser(username: string) {
    this.standardHttpOptionsWithUser = {
      withCredentials: true,
      headers: new HttpHeaders({
        ['Content-Type']: 'application/json',
        username
      })
    };
  }


  public askAI(askQuestionRequest: AskQuestionRequest): Observable<any> {
    this.loadingService.setMessage('asking AI ...');
    return this.http.post(`${ this.apiUrl }/ai/ask`, JSON.stringify(askQuestionRequest), standardHttpOptions).pipe(
      map((response: Response) => response),
      catchError(this.handleError),
      finalize(() => this.loadingService.clearMessage())
    );
  }



  private handleError(error: any) {
    if (error.status === 404) {
      return of(null);
    }
    return throwError(() => error);
  }


}
